import startCase from 'lodash/startCase';
import format from 'date-fns-old/format';

const createSurveyPdfName = (surveyName, userName, date) => {
  const uiSurveyName = surveyName && startCase(surveyName);
  const uiDate = format(date, 'MMM DD YYYY');
  const pdfName = `${uiSurveyName} - ${userName} - ${uiDate}`;

  return pdfName.split(' ').join('_');
};

export default createSurveyPdfName;



// WEBPACK FOOTER //
// ./src/utils/createSurveyPdfName.js